import React from 'react';
import { Formation } from '@/components/team/FormationPitch';
import {PositionMap, TeamSelectionPlayer} from './types';
import {Link} from 'react-router-dom';

interface SelectedPlayersBenchProps {
  formation: Formation;
  selected: PositionMap;
  players: TeamSelectionPlayer[];
  benchIds: string[];
  onRemoveFromPosition: (posId: string) => void;
  onAddToBench: (p: TeamSelectionPlayer) => void;
  onRemoveFromBench: (id: string) => void;
}

const SelectedPlayersBench: React.FC<SelectedPlayersBenchProps> = ({
  formation,
  selected,
  players,
  benchIds,
  onRemoveFromPosition,
  onAddToBench,
  onRemoveFromBench,
}) => {
  return (
    <div className="mt-4">
      <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-200 mb-2">Selected Players</h3>
      <div className="flex flex-wrap gap-2">
        {formation.positions.map((pos) => (
          <div key={pos.id} className="flex items-center gap-1 rounded border border-gray-300 dark:border-gray-700 px-2 py-1 text-xs">
            <span className="font-semibold">{pos.label}:</span>
            {selected[pos.id]
              ? <Link to={`/players/${selected[pos.id]!.id}`} aria-label={`View ${selected[pos.id]!.name}`}>{selected[pos.id]!.name}</Link>
              : <span>—</span>}
            {selected[pos.id] && (
              <>
                <button className="ml-1 text-red-600 hover:underline" onClick={() => onRemoveFromPosition(pos.id)}>Remove</button>
                <button className="ml-1 text-primary-600 hover:underline" onClick={() => onAddToBench(selected[pos.id] as TeamSelectionPlayer)}>Bench</button>
              </>
            )}
          </div>
        ))}
      </div>
      {/* Bench summary */}
      <div className="mt-3">
        <h4 className="text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">Bench ({benchIds.length})</h4>
        <div className="flex flex-wrap gap-2">
          {benchIds.map((id) => {
            const p = players.find((pp) => pp.id === id);
            if (!p) return null;
            return (
              <div key={id} className="flex items-center gap-1 rounded border border-gray-300 dark:border-gray-700 px-2 py-1 text-xs">
                <Link className="font-medium" to={`/players/${p.id}`} aria-label={`View ${p.name}`}>{p.name}</Link>
                <button className="text-red-600 hover:underline" onClick={() => onRemoveFromBench(id)}>Remove</button>
              </div>
            );
          })}
          {benchIds.length === 0 && <span className="text-xs text-gray-500">No players on bench</span>}
        </div>
      </div>
    </div>
  );
};

export default SelectedPlayersBench;
